import React, { Component, createRef } from 'react'
import Chart from 'chart.js'

import { Box } from '@chatterbug/aaron'

import { adjustAxes } from './helpers/adjustAxes'
import { DefaultChartOptions } from './helpers/graphOptions'

export default class FlashcardsGraph extends Component {
  chartRef = createRef()

  componentDidMount() {
    const myChartRef = this.chartRef.current.getContext('2d')
    // eslint-disable-next-line no-new
    new Chart(myChartRef, {
      type: 'line',
      data: this.props.data,
      options: DefaultChartOptions(this.props.data),
      plugins: [
        {
          afterDraw: function(chart) {
            adjustAxes(chart, Chart.helpers)
          },
        },
      ],
    })
  }
  render() {
    return (
      <Box
        id="graph-line-parent"
        height={{ _: '260px', desktop: '316px' }}
        sx={{ position: 'relative', overflow: 'hidden' }}
      >
        <canvas id="flashcards" ref={this.chartRef} />
      </Box>
    )
  }
}
